import type { Emoji } from '@getaccept/fried-tofu';

export const EMOJI_INLINE_TRIGGER_COUNT = 3;

export const CUSTOM_EMOJI_LIST: Emoji[] = [
  // {
  //   name: 'GetAccept',
  //   short_names: ['getaccept'],
  //   text: '',
  //   emoticons: [],
  //   custom: true,
  //   keywords: ['ga', 'getaccept'],
  //   imageUrl: '/assets/img/favicon.png',
  // },
];
